import { useMemo } from 'react';

import {
  CONTENT_POSITION_TYPES,
  CONTENT_POSITION_TYPES as CONTENT_POSITIONS,
  CONTENT_TYPES,
} from '@/constants';
import { useContentWithSSRProtection, usePageProps } from '@/hooks';
// import { useGetContentQuery } from '@/queries';

export const useGetContentQueryData = () => {
  const { location, intl } = usePageProps();
  // const {
  //   data = {},
  //   status,
  //   error,
  // } = useGetContentQuery({
  //   locale: intl.locale,
  //   pathname: location.pathname,
  // });
  const { data, status, error } = useContentWithSSRProtection({
    locale: intl.locale,
    pathname: location.pathname,
  });

  const isFetching = status === 'pending';
  const isRequestError = status === 'rejected';
  const isLoaded = status === 'fulfilled';

  return useMemo(
    () => ({ data, isFetching, isRequestError, isLoaded, error }),
    [data, status]
  );
};

// export const useGetContentSeoMeta = () => {
//   const { data = {}, error } = useGetContentQueryData();
//   const { h1, title, description, previewText } = data?.meta || {};
//
//   return useMemo(
//     () => ({ h1, title, description, previewText, error }),
//     [h1, title, description, previewText, error]
//   );
// };

export const useGetContentBlocks = () => {
  const { data = {}, ...rest } = useGetContentQueryData();

  const contentBlocks = data?.contentBlocks || {};

  return useMemo(() => ({ contentBlocks, ...rest }), [contentBlocks]);
};

export const useGetContentHeaderMenu = () => {
  const { data, isFetching, isRequestError } = useGetContentQueryData();

  const headerBottomContent =
    data?.contentBlocks?.[CONTENT_POSITIONS.headerBottom];

  const menuItems = useMemo(() => {
    if (isFetching || isRequestError) return [];

    return (
      headerBottomContent?.find(
        (item) =>
          item.type === 'menu' &&
          item.position === CONTENT_POSITION_TYPES.headerBottom
      )?.items || []
    );
  }, [headerBottomContent, isFetching, isRequestError]);

  return menuItems;
};

export const useGetTableOfContent = ({ staticContent }) => {
  const { intl } = usePageProps();
  const { data = {}, isFetching = false } = useGetContentQueryData();
  const tableOfContent = data?.tableOfContent || [];
  const contentBottom = data?.contentBlocks?.content_bottom || [];

  return useMemo(
    () => ({
      tableOfContent: contentBottom
        // .sort((a, b) => a.order - b.order)
        .reduce((res, cur) => {
          const currenHtmlContent = tableOfContent?.[cur.id];
          if (cur?.type === CONTENT_TYPES.html && currenHtmlContent) {
            return [...res, ...currenHtmlContent];
          }

          if (cur?.type === CONTENT_TYPES.static) {
            return [
              ...res,
              ...(staticContent?.map((item) => ({
                id: item,
                label: intl.formatMessage({
                  id: `staticContent.anchorLinks.map.title.${item}`,
                }),
              })) || []),
            ];
          }

          return res;
        }, []),
      isFetching,
    }),
    [tableOfContent, staticContent, contentBottom, isFetching]
  );
};

// export const useGetContentFilters = () => {
//   const { location, intl } = usePageProps();
//   const { data = {}, isFetching = false } = useGetContentQuery({
//     locale: intl.locale,
//     pathname: location.pathname,
//   });
//   const filters = data?.filters || {};
//
//   return useMemo(() => ({ filters, isFetching }), [filters, isFetching]);
// };
